import { render, staticRenderFns } from "./KnowledgeBaseCategoryPublicationEdit.vue?vue&type=template&id=7e27b7ec&"
import script from "./KnowledgeBaseCategoryPublicationEdit.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseCategoryPublicationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports